import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const ChartWrap = styled.section`
  display: flex;
  justify-content: center;
  margin: 120px auto 0;
  max-width: 1100px;
  width: 100%;
  @media (max-width: 769px) {
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
    button {
      width: 100%;
    }
  }
`;

export const FirstHalf = styled.div`
  max-width: 50%;
  width: 100%;
  margin: 0 auto;
  height: 461px;
  background-image: url("/images/chart.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 0;
  @media (max-width: 769px) {
    background-image: url("/images/chart_mobile.png");
    max-width: 328px;
    height: 308px;
  }
`;

export const SecondHalf = styled.div`
  margin-top: 23px;
  width: 100%;
  p {
    margin-top: 19px;
  }
  @media (min-width: 769px) {
    padding-left: 10.2%;
    margin-top: 18px;
    max-width: 46%;
  }
`;

export const Title = styled.h1`
  margin-bottom: 28px;
  font-size: 48px;
  line-height: 57px;
  color: ${colors.GREY_DARK};
  color: ${(props) => (props.color === "red" ? colors.RED : colors.GREY_DARK)};
  font-family: ${fonts.abhayaBold};
  @media (max-width: 769px) {
    font-size: 36px;
    line-height: 42px;
    text-align: center;
    margin-bottom: 38px;
  }
`;
export const SubTitle = styled.span`
  margin: 0;
  color: ${(props) => (props.color === "red" ? colors.RED : colors.GREY_DARK)};
`;

export const Text = styled.p`
  color: ${(props) => (props.color === "gray" ? colors.GREY : colors.GREY_DARK)};
  font-family: ${fonts.latoRegular};
  font-weight: normal;
  font-size: ${(props) => `${props.fontSize}px`};
  line-height: 22px;
  width: 380px;
  display: flex;
  align-items: center;
  span {
    margin-left: 16px;
  }
  @media (max-width: 769px) {
    font-size: 16px;
    width: 100%;
  }
`;
export const ButtonBox = styled.div`
  margin-top: 42px;
  button {
    margin-bottom: 4px;
  }
  @media (min-width: 769px) {
    margin-top: 32px;
  }
`;
export const TextColor = styled.span`
  color: ${colors.GREY_DARK};
`;
